export const States = [
  { text: "Select State" },
  { text: "Andaman and Nicobar Islands" },
  { text: "Andhra Pradesh" },
  { text: "Arunachal Pradesh" },
  { text: "Assam" },
  { text: "Bihar" },
  { text: "Chandigarh" },
  { text: "Chhattisgarh" },
  { text: "Dadra and Nagar Haveli and Daman and Diu" },
  { text: "Delhi" },
  { text: "Goa" },
  { text: "Gujarat" },
  { text: "Haryana" },
  { text: "Himachal Pradesh" },
  { text: "Jammu and Kashmir" },
  { text: "Jharkhand" },
  { text: "Karnataka" },
  { text: "Kerala" },
  { text: "Ladakh" },
  { text: "Lakshadweep" },
  { text: "Madhya Pradesh" },
  { text: "Maharashtra" },
  { text: "Manipur" },
  { text: "Meghalaya" },
  { text: "Mizoram" },
  { text: "Nagaland" },
  { text: "Odisha" },
  { text: "Puducherry" },
  { text: "Punjab" },
  { text: "Rajasthan" },
  { text: "Sikkim" },
  { text: "Tamil Nadu" },
  { text: "Telangana" },
  { text: "Tripura" },
  { text: "Uttar Pradesh" },
  { text: "Uttarakhand" },
  { text: "West Bengal" },
];
